import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { NavigationService } from 'src/app/modules/projeto-completo/services/navigation.service';
import { ProjetoLegislacaoService } from '../../../services/projeto-legislacao.service';
import { ProjetoCadastroService } from '../../../services/projeto-cadastro.service';
import { environment } from 'src/environments/environment';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-projeto-legislacao-list',
  templateUrl: './projeto-legislacao-list.component.html',
  styleUrls: ['./projeto-legislacao-list.component.scss']
})
export class ProjetoLegislacaoListComponent extends BaseListComponent<any> implements OnInit, OnDestroy {

  idProjeto: number;
  legislacaoList: any[];
  canDeleteProj: boolean;
  canCloneProj: boolean;
  modalCloneRef?: BsModalRef;
  clone_title: string;

  @ViewChild('modalClone') modalClone: TemplateRef<any>;

  constructor(
    private myService: ProjetoLegislacaoService,
    private projetoService: ProjetoCadastroService,
    public activatedRoute: ActivatedRoute,
    private modalService: BsModalService,
    private navigation: NavigationService
  ) {
    super();
  }

  ngOnInit() {
    this.idProjeto = this.activatedRoute.parent.snapshot.params?.id;
    this.initList();
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }

  initList() {
    if (this.idProjeto) {
      this.addSub(
        this.myService.getListAll(this.idProjeto).subscribe({
          next: (res) => {
            this.legislacaoList = res['list'];
            this.canDeleteProj = res['canDeleteProj'];
            this.canCloneProj = res['canCloneProj'];
            this.loaded();
          },
          error: (error) => {
            this.msgError(error?.error?.message);
            this.loaded();
          },
        })
      );
    }
  }

  confirmExcluir() {
    this.alertConfirmation(null, 'Tem certeza que deseja excluir o projeto?').subscribe((confirmed) => {
      if (confirmed) {
        this.excluir();
      }
    });
  }

  excluir(): void {
    this.loading();
    this.projetoService.delete(this.idProjeto).subscribe({
      next: () => {
        this.confirmation('Deletado com sucesso').subscribe(() => {
          this.navigation.replace(['/pre-projeto', 'projeto']);
        });
      },
      error: (error) => {
        this.loaded();
        this.msgError(error?.error);
      },
    });
  }

  closeCloneModal() {
    this.modalCloneRef?.hide();
  }

  openCloneModal() {
    this.clone_title = '';
    this.modalCloneRef = this.modalService.show(this.modalClone);
  }

  clonar() {
    this.closeCloneModal();
    this.loading();
    if (this.idProjeto && this.canCloneProj) {
      const obj = {
        clone_id: this.idProjeto,
        clone_title: this.clone_title,
      };
      this.addSub(
        this.projetoService.clonar(obj).subscribe({
          next: () => {
            this.msgSuccess('Clonado com sucesso!');
            this.loaded();
          },
          error: (error) => {
            this.msgError(error?.error?.message);
            this.loaded();
          },
        })
      );
    }
  }

  imprimir() {
    this.loading();
    const url = `${environment.serverUrl}/rest/pre-projeto/relatorio/${this.idProjeto}`;
    this.loaded();
    window.open(url, '_blank');
  }

  voltar() {
    this.navigation.back(['/pre-projeto', 'projeto']);
  }
}